import { defineMessages } from 'react-intl';

// Main route
const registerScope = 't.page.register';

// Global scope
const globalScope = 't.global';

// Navigation
const navigationScope = 't.component.PortalAppNavigation';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
	successfullyDelete: {
		id: `${registerScope}.successfullyDelete`,
		defaultMessage: 'Cassa eliminata con successo',
	},
	failureDelete: {
		id: `${registerScope}.failureDelete`,
		defaultMessage: 'Eliminazione cassa fallita',
	},
	deleteSubtitle: {
		id: `${registerScope}.deleteSubtitle`,
		defaultMessage: 'della cassa',
	},
	detailTitle: {
		id: `${registerScope}.detailTitle`,
		defaultMessage: 'Dettaglio cassa',
	},
	registerEditing: {
		id: `${registerScope}.registerEditing`,
		defaultMessage: 'Modifica cassa',
	},
	registerCreation: {
		id: `${registerScope}.registerCreation`,
		defaultMessage: 'Crea cassa',
	},
	newRegisterTitle: {
		id: `${registerScope}.newRegisterTitle`,
		defaultMessage: 'Inserisci i dati della cassa',
	},
	registerCreatedSuccessfully: {
		id: `${registerScope}.registerCreatedSuccessfully`,
		defaultMessage: 'Cassa creata con successo',
	},
	registerNotCreatedSuccessfully: {
		id: `${registerScope}.registerNotCreatedSuccessfully`,
		defaultMessage: 'Creazione cassa fallita',
	},
	registerUpdatedSuccessfully: {
		id: `${registerScope}.registerUpdatedSuccessfully`,
		defaultMessage: 'Cassa modificata con successo',
	},
	registerUpdatedNotSuccessfully: {
		id: `${registerScope}.registerUpdatedNotSuccessfully`,
		defaultMessage: 'Modifica cassa fallita',
	},
	goBackModalButton: {
		id: `${registerScope}.goBackModalButton`,
		defaultMessage: "Torna all'elenco casse",
	},
	posData: {
		id: `${registerScope}.posData`,
		defaultMessage: 'Informazioni pos',
	},
	shopId: {
		id: `${registerScope}.shopId`,
		defaultMessage: 'ID Negozio',
	},
	registerData: {
		id: `${registerScope}.registerData`,
		defaultMessage: 'Dati cassa',
	},
	default: {
		id: `${registerScope}.default`,
		defaultMessage: 'Default',
	},
	enabled: {
		id: `${registerScope}.enabled`,
		defaultMessage: 'Abilitato',
	},

	// Navigation Scope
	pageTitle: {
		id: `${navigationScope}.register.registerList`,
		defaultMessage: 'Elenco Casse',
	},
	newRegister: {
		id: `${navigationScope}.register.registerManagement`,
		defaultMessage: 'Crea Cassa',
	},

	// Global Scope
	name: {
		id: `${globalScope}.name`,
		defaultMessage: 'Nome',
	},
	merchant: {
		id: `${globalScope}.merchant`,
		defaultMessage: 'Merchant',
	},
	group: {
		id: `${globalScope}.group`,
		defaultMessage: 'Gruppo',
	},
	creationDate: {
		id: `${globalScope}.creationDate`,
		defaultMessage: 'Data creazione',
	},
	abortLabelButton: {
		id: `${globalScope}.abort`,
		defaultMessage: 'Annulla',
	},
	createLabelButton: {
		id: `${globalScope}.create`,
		defaultMessage: 'Crea',
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
		defaultMessage: 'Conferma',
	},
	saveLabelButton: {
		id: `${globalScope}.save`,
		defaultMessage: 'Salva',
	},
	emptyString: {
		id: `${globalScope}.emptyString`,
		defaultMessage: ' ',
	},
	edit: {
		id: `${globalScope}.edit`,
		defaultMessage: 'Modifica',
	},
	warning: {
		id: `${globalScope}.warning`,
		defaultMessage: 'Attenzione',
	},
	subtitleDelete: {
		id: `${globalScope}.subtitleDelete`,
		defaultMessage: 'Sei sicuro di voler procedere alla cancellazione {element}?',
	},
	country: {
		id: `${globalScope}.country`,
		defaultMessage: '"Nazione"',
	},
	county: {
		id: `${globalScope}.county`,
		defaultMessage: 'Provincia',
	},
	address: {
		id: `${globalScope}.address`,
		defaultMessage: 'Indirizzo',
	},
	cap: {
		id: `${globalScope}.cap`,
		defaultMessage: 'Cap',
	},
	municipality: {
		id: `${globalScope}.municipality`,
		defaultMessage: 'Comune',
	},
	terminal: {
		id: `${globalScope}.terminal`,
		defaultMessage: 'Terminale',
	},
	password: {
		id: `${globalScope}.password`,
		defaultMessage: 'Password',
	},
	url: {
		id: `${globalScope}.url`,
		defaultMessage: 'URL',
	},
	id: {
		id: `${globalScope}.id`,
		defaultMessage: 'ID',
	},
	apiKey: {
		id: `${globalScope}.apiKey`,
		defaultMessage: 'ApiKey',
	},
	shop: {
		id: `${globalScope}.shop`,
		defaultMessage: 'Negozio',
	},
	addShop: {
		id: `${globalScope}.selectShop`,
		defaultMessage: 'Seleziona Negozio',
	},
	personalData: {
		id: `${globalScope}.personalData`,
		defaultMessage: 'Dati anagrafici',
	},
	showDate: {
		id: `${globalScope}.showDate`,
		defaultMessage: 'Visualizza data',
	},

	//Errors Global Scope
	invalidDate: {
		id: `${globalErrorsScope}.invalidDate`,
		defaultMessage: 'Data non valida',
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalErrorsScope}.theSecondDateIsMinorThanFirst`,
		defaultMessage: 'Data di fine troppo piccola',
	},
	fillFirstDateToContinueValidation: {
		id: `${globalErrorsScope}.fillFirstDateToContinueValidation`,
		defaultMessage: "Data d'inizio mancante",
	},
	fieldRequested: {
		id: `${globalErrorsScope}.fieldRequested`,
		defaultMessage: 'Campo obbligatorio',
	},
	maxLength: {
		id: `${globalErrorsScope}.maxLength`,
		defaultMessage: 'Superata lunghezza massima',
	},
});
